import { ITransactions } from "features/Crm/modules/Transactions/Transactions.interfaces";
import React from "react";

export const KYCDetailsField = ({
  answers,
}: {
  answers: ITransactions.BookingResponse["answer_list"];
}) => {
  return (
    <div className="tw-text-sm">
      {answers.map(({ question, answer }) => (
        <div key={question}>
          <strong>{question}</strong>: {answer}
        </div>
      ))}
    </div>
  );
};
